var Component = require("enyo/Component"),
    kind      = require("enyo/kind"),
    logger    = require("enyo/logger"),
    throttle  = require("enyo-perf/utils").throttle;

module.exports = kind(/** @lends  app.MediaPlayer.ProgressTrackers.ImageProgressTracker.prototype */ {

    /**
     * @private
     */
    name: "app.MediaPlayer.ProgressTrackers.ImageProgressTracker",

    /**
     * @private
     */
    kind: Component,

    /**
     * The viewer.
     *
     * @type  {app.MediaPlayer.Tech.Astract.AbstractImageViewer}
     * @private
     */
    playerTech: null,

    /**
     * The maximum frequency of pings. Prevents flooding the backend with pings.
     * Time set in milliseconds.
     *
     * @public
     */
    pingTimeout: 250,

    /**
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            sup.apply(this, arguments);
            this.ping = throttle(this.bindSafely(this.ping), this.pingTimeout);
            this.observe("playerTech.activeImage.isLoading", this.ping);
        };
    }),

    /**
     * Submit playback progress.
     *
     * @private
     */
    ping: function() {
        var $watchingSessionService = this.app.$.watchingSessionService,
            $playerTech             = this.playerTech,
            activeImage             = $playerTech ? $playerTech.get("activeImage") : null,
            isLoading               = activeImage ? activeImage.get("isLoading") : null;

        if (!$playerTech
            || $watchingSessionService.hasSession !== 1
            || !$watchingSessionService.hasPingEndpoint()
            || !activeImage
            || isLoading) {
            return;
        }

        $watchingSessionService.updateCursor(0)
            .then(this.bindSafely(function(response) {
                if (response.status !== "ok" && response.status !== "canceled") {
                    this.controller.triggerHandler("onProgressTrackerError", {
                        type: response.type
                    });
                }
            }))
            .catch(this.bindSafely(function(error) {
                logger.error(error);

                if (typeof Sentry !== "undefined" && error instanceof Error) {
                    Sentry.captureException(error);
                }

                this.controller.triggerHandler("onProgressTrackerError", {
                    type:    "progress_tracker_error",
                    message: error
                });
            }));
    },

    /**
     * @private
     */
    destroy: kind.inherit(function(sup) {
        return function() {
            this.ping();
            sup.apply(this, arguments);
        };
    })

});
